import { ReactNode, useState } from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import { useItems } from './hooks/use-items.tsx';

import styles from './styles.module.scss';

export function ColumnsConfigurator<T>(): ReactNode {
    const [open, setOpen] = useState(false);
    const items = useItems<T>();

    return (
        <Dropdown
            menu={{
                items,
            }}
            rootClassName={styles.columnsConfigurator}
            placement="topLeft"
            trigger={['click']}
            open={open}
            onOpenChange={(open, info) => {
                if (info.source === 'trigger') {
                    setOpen(open);
                }
            }}
        >
            <Button type="primary" color="blue" icon={<SettingOutlined />}>
                Customize table
            </Button>
        </Dropdown>
    );
}
